import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { env } from '@/lib/env';
import { mockStore } from '@/lib/mockStore';
import type { DashboardSnapshot } from '@daily/shared';

export function useDashboard() {
  const qc = useQueryClient();

  useEffect(() => {
    if (!env.mock) return;
    return mockStore.subscribe(() => qc.invalidateQueries({ queryKey: ['dashboard'] }));
  }, [qc]);

  return useQuery<DashboardSnapshot>({
    queryKey: ['dashboard'],
    queryFn: () => api.getDashboard(),
    refetchInterval: env.mock ? false : 60_000,
    staleTime: 30_000,
    // Keep showing the current snapshot while the 60s refetch runs in the
    // background, so the wall never blanks or flickers to a loading state.
    placeholderData: (prev) => prev,
  });
}
